module.exports = __webpack_public_path__ + "static/img/two.846b984.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/component/product_intro/two.svg
// module id = 5YLH
// module chunks = 30